/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Select_Group_AriaInputs */

const en_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select group to manage`)
};

const fr_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner le groupe à gérer`)
};

const de_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe zur Verwaltung auswählen`)
};

const it_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il gruppo da gestire`)
};

const ru_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группу для управления`)
};

const es_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el grupo a administrar`)
};

const zh_cn2_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要管理的组`)
};

const ja_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理するグループを選択`)
};

const hi_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रबंधित करने के लिए समूह का चयन करें`)
};

const pt_pt2_team_manager_select_group_aria = /** @type {(inputs: Team_Manager_Select_Group_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o grupo a ser gerenciado`)
};

/**
* | output |
* | --- |
* | "Select group to manage" |
*
* @param {Team_Manager_Select_Group_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_select_group_aria = /** @type {((inputs?: Team_Manager_Select_Group_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Select_Group_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_select_group_aria(inputs)
	if (locale === "de") return de_team_manager_select_group_aria(inputs)
	if (locale === "it") return it_team_manager_select_group_aria(inputs)
	if (locale === "ru") return ru_team_manager_select_group_aria(inputs)
	if (locale === "es") return es_team_manager_select_group_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_select_group_aria(inputs)
	if (locale === "ja") return ja_team_manager_select_group_aria(inputs)
	if (locale === "hi") return hi_team_manager_select_group_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_select_group_aria(inputs)
	return en_team_manager_select_group_aria(inputs)
});